


































import { Vue, Component, Prop, Emit, Ref } from "vue-property-decorator";
import { vxm } from "@/store";

@Component({})
export default class DeleteMediumDialog extends Vue {
  @Prop() value!: boolean;
  @Ref("form") form: any;

  loading = false;

  @Emit("input")
  close() {
    return false;
  }

  async deleteMedium() {
    try {
      this.loading = true;
      await vxm.results.deleteMedium();
      this.close();
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  }
}
